import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon, Text } from "@flat-ui";
import { Box, ButtonBase } from "@mui-wrapper";
import { AnnotationSidePanelEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useId, useState } from "react";
/**
 * Collapsed section for secondary annotation details, e.g. the activity: only a title with a
 * chevron, styled like the other titles of the side panel, e.g. the description
 */
export function MarkupSidePanelSection(t0) {
  const $ = _c(25);
  const {
    title,
    children,
    trackingName,
    dataTestId
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== isExpanded || $[1] !== trackEvent || $[2] !== trackingName) {
    t1 = function toggle() {
      setIsExpanded(!isExpanded);
      trackEvent({
        name: AnnotationSidePanelEvents.toggleSection,
        props: {
          section: trackingName,
          isExpanded: !isExpanded
        }
      });
    };
    $[0] = isExpanded;
    $[1] = trackEvent;
    $[2] = trackingName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const toggle = t1;
  const contentId = useId();
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: 2
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: 0.5,
      borderRadius: 0.5,
      "&:focus-visible": {
        outline: "2px solid",
        outlineColor: "primary.main"
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "text.secondary"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== title) {
    t5 = <Text variant="heading12" component="span" sx={t4}>{title}</Text>;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isExpanded ? "rotate(90deg)" : undefined;
  let t7;
  if ($[9] !== t6) {
    t7 = <ChevronRightIcon sx={{
      width: "1rem",
      height: "1rem",
      color: "text.secondary",
      transform: t6,
      transition: "transform 150ms"
    }} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== contentId || $[12] !== isExpanded || $[13] !== t5 || $[14] !== t7 || $[15] !== toggle) {
    t8 = <ButtonBase aria-expanded={isExpanded} aria-controls={contentId} onClick={toggle} disableRipple={true} sx={t3}>{t5}{t7}</ButtonBase>;
    $[11] = contentId;
    $[12] = isExpanded;
    $[13] = t5;
    $[14] = t7;
    $[15] = toggle;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== children || $[18] !== contentId || $[19] !== isExpanded) {
    t9 = isExpanded && <Box id={contentId} sx={{
      pt: 1
    }}>{children}</Box>;
    $[17] = children;
    $[18] = contentId;
    $[19] = isExpanded;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== dataTestId || $[22] !== t8 || $[23] !== t9) {
    t10 = <Box sx={t2} data-testid={dataTestId}>{t8}{t9}</Box>;
    $[21] = dataTestId;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}